import React, { useState, SyntheticEvent } from 'react';
import { FormProps } from '../AccountCreationForm';
import { Form, Field as FormikField } from 'formik';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { H3, Body2 } from '@xo-union/tk-ui-typography';
import { Field } from '../../../../libs/gs-component-form';
import { DisplayButton } from '@xo-union/tk-ui-links';
import NonSubmittableBlankButton from '../NonSubmittableBlankButton';
import Alert from '../Alert';
import LoadingOverlay from '../LoadingOverlay';
import Continue from '../Continue';
import styles from '../BasicInfoForm/index.scss';
import OnboardingMembershipModal from '../../../OnboardingMembershipModal';

const CredentialsFields: React.FC<FormProps> = ({ loading, onLogin, erroring, errorMessage, onAlertTimeout }) => {
  const [openModal, setOpenModal] = useState<string | null>(null);
  const createAccount = () => onLogin && onLogin();

  return (
    <div className={styles.wrapper}>
      <Alert erroring={erroring} errorMessage={errorMessage} onTimeout={onAlertTimeout} />
      <Body2 className={styles.steps}>
        Step 2 of 2
        <br />
      </Body2>
      <H3 className={styles.header}>Sign up to create your website</H3>
      <Form>
        <LoadingOverlay loading={loading} />
        <FormBlockColumn>
          <FormikField name="email" label="Email" component={Field} data-testid="email" />
        </FormBlockColumn>
        <FormBlockColumn>
          <FormikField name="password" label="Password" component={Field} data-testid="password" type="password" />
        </FormBlockColumn>
        <Body2 className={`${styles.subhead} ${styles.finePrint} ${styles.legal}`}>
          By signing up, you agree to The Knot's{' '}
          <a href="https://www.theknot.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>
          . See our{' '}
          <a href="https://www.theknot.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{' '}
          for data practices.
        </Body2>

        <Continue buttonText={'Sign up'} />

        <Body2 className={`${styles.subhead} ${styles.finePrint} ${styles.logInPrompt}`}>
          Already a member?{' '}
          <DisplayButton
            onClick={(evt: SyntheticEvent) => {
              evt.preventDefault();
              evt.stopPropagation();
              setOpenModal('LOG_IN');
            }}
            className={styles.loginButton}
            as={NonSubmittableBlankButton}
            data-testid="loginButton"
          >
            Log In
          </DisplayButton>
        </Body2>
      </Form>
      <OnboardingMembershipModal
        onAccountCreated={createAccount}
        currentModal={openModal}
        onClose={() => setOpenModal(null)}
      />
    </div>
  );
};

export default CredentialsFields;
